import { signal } from "@angular/core";

export const haveLeitor = signal<boolean>(false);